<!--
画面内に「しばらくお待ちください」を表示するモジュール
 -->

<template>
  <v-overlay :value="true">
    <v-progress-circular :size="80" indeterminate></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {};
</script>

<style></style>
